// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__3BBsU","container":"styles_container__2Uzpa","title":"styles_title__3lfBR","wrapper":"styles_wrapper__CPpPP","answer":"styles_answer__34_D-"};